import SettingsCalls from '../../model/settings/Calls';
import { AppDispatch, AppStore } from '../../redux/store.model';
import { actionsFeatureToggle } from './slice';

export const saveDefaultApplication =
  (defaultApplication: string) => async (dispatch: AppDispatch) => {
    const settingsCalls = new SettingsCalls();

    await settingsCalls.setSetting('ApplicationDefault', defaultApplication);
    await dispatch(
      actionsFeatureToggle.updateToggle({
        name: 'ApplicationDefault',
        value: defaultApplication,
      })
    );
  };

export const getSavedFeatureToggles =
  () => async (dispatch: AppDispatch, getState: AppStore['getState']) => {
    const settingsCalls = new SettingsCalls();

    const savedConfiguration = await settingsCalls.getAllSetting();

    // we can override featureToggles with saved settings at the moment there not collisions
    await dispatch(actionsFeatureToggle.updateToggles(savedConfiguration));
  };
